<template>
    <div class="usage-reports container pa-12">
       <h2>Usage Report</h2>
       <div class="d-flex align-center mt-2">
            <v-autocomplete v-model="selectedEnv" :items="envList" label="Select Environment" outlined dense @change="getTenet(selectedEnv)"></v-autocomplete> 
            <v-autocomplete v-model="selectedTenet" :items="tenetList" item-text="name" item-value="_id" label="Select Tenant" outlined dense class="ml-2" :disabled="selectedEnv == ''"></v-autocomplete>
            <v-menu ref="startmenu" v-model="startdateMenu" :close-on-content-click="false" :return-value.sync="startDate" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="startDate" label="Start Date" outlined dense readonly v-bind="attrs" v-on="on" :disabled="selectedTenet == ''"  class="ml-2"></v-text-field>
                </template>
                <v-date-picker v-model="startDate" :max="maxDate" no-title scrollable>
                    <v-spacer></v-spacer>
                <v-btn text color="primary" @click="startdateMenu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.startmenu.save(startDate)">OK</v-btn>
                </v-date-picker>
            </v-menu>
            <v-menu ref="endmenu" v-model="enddateMenu" :close-on-content-click="false" :return-value.sync="endDate" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="endDate" label="End Date" outlined dense readonly v-bind="attrs" v-on="on" :disabled="startDate == ''"  class="ml-2"></v-text-field>
                </template>
                <v-date-picker v-model="endDate" :min="startDate" :max="maxDate" no-title scrollable>
                    <v-spacer></v-spacer>
                <v-btn text color="primary" @click="enddateMenu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.endmenu.save(endDate)">OK</v-btn>
                </v-date-picker>
            </v-menu>
       </div>
       <div class="d-flex justify-center mt-2 mb-2">
            <v-alert type="info" outlined dense border-left>
                Please fill all the parameters given above to View or Download the reports.
            </v-alert>
       </div>
       <div class=" d-flex align-center justify-center text-center mt-2">
            <div style="width: 250px;" class="mr-6">
                <v-autocomplete v-model="selectedReportType" :items="reportList" class="report-drop" label="Select Report Type" outlined dense item-text="name" item-value="id" @change="reportChange"></v-autocomplete>
            </div>
            <v-btn v-if="selectedReportType == 'tbe'" color="success" elevation="0" rounded @click="getRepost" :disabled="selectedEnv == '' || selectedTenet == '' || startDate == '' || endDate == '' || selectedReportType == ''">Generate Report</v-btn>
            <v-btn v-if="selectedReportType != 'tbe'" color="success" elevation="0" rounded @click="exportRepost" :disabled="selectedEnv == '' || selectedTenet == '' || startDate == '' || endDate == '' || selectedReportType == ''">Generate Report</v-btn>
            <v-btn color="info" class="ml-6" elevation="0" rounded v-if="downloadUrl != ''" @click="downloadReport">Download Report</v-btn>
            <v-btn color="error" text elevation="0" rounded class="ml-2" v-if="selectedEnv != '' || selectedTenet != '' || startDate != '' || endDate != ''" @click="resetInput">Reset</v-btn>
       </div>
       <div class="report-view mt-12" v-if="showReport">
            <div class="d-flex align-center justify-end">
                <b>Total Bid Tab Count:</b> <v-chip color="success" class="ml-1" small>{{ total_count }}</v-chip>
                <v-btn color="info" class="ml-6" elevation="0" small rounded @click="exportRepost" :disabled="selectedEnv == '' || selectedTenet == '' || startDate == '' || endDate == ''">Download Report</v-btn>
            </div>
            <div>
                <!-- {{ report }} -->
                  <v-data-table
                    :headers="headers"
                    :items="report"
                    class="elevation-1 mt-4"
                  >
                    <template v-slot:item.item_type="{item}">
                        <table style="width: 100%;">
                            <tbody>
                                <tr  v-for="(itm, i) in item.item_type" :key="i" class="item-row">
                                    <td>
                                        {{ itm.name }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <template v-slot:item.item_cat="{item}">
                        <table style="width: 100%;">
                            <tbody>
                                <tr  v-for="(itm, i) in item.item_cat" :key="i" class="item-row">
                                   
                                    <td>
                                        {{ itm.val }}
                                    </td>
                                    
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <template v-slot:item.item_cnt="{item}">
                        <table style="width: 100%;">
                            <tbody>
                                <tr  v-for="(itm, i) in item.item_cnt" :key="i" class="item-row">
                                    
                                    <td>
                                        {{itm.type}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <template v-slot:no-data>
                        No report available for selected dates.
                    </template>
                  </v-data-table>
            </div>
       </div>

       <div class="loader" v-if="loader">
        <v-progress-circular
        indeterminate
        color="green"
        ></v-progress-circular>
        Generating Report please wait...
       </div>
        <v-snackbar v-model="snackbar" color="success">
            Report generated successfully. <br> Use the <b>Download</b> button <br> to download the report.
        </v-snackbar>
        <v-snackbar v-model="successAlert" color="success">
           {{ successMessage }}
        </v-snackbar>
         <v-snackbar v-model="errorAlert" color="error">
           {{ errorMessage }}
        </v-snackbar>
    </div>
</template>
<script>
import moment from 'moment'
import axios from 'axios'
  
export default {
    data: () => ({
        successAlert: false,
        successMessage: '',
        errorAlert: false,
        errorMessage: '',
        snackbar: false,
        reportList:[],
        selectedReportType: '',
        headers: [
        { text: 'Project', value: 'project_name' },
        { text: 'Item Name', value: 'item_type', align:'left', sortable: false },
        { text: 'Category', value: 'item_cnt', align:'left', sortable: false },
        { text: 'Bid Tab Count', value: 'item_cat', align:'center', sortable: false },
        { text: 'Total Bid Tab Count', value: 'mr_count', align:'center' },
        ],
        envList: [],
        selectedEnv: '',
        selectedTenet: '',
        tenetList: [],
        startdateMenu: false,
        startDate: '',
        enddateMenu: false,
        endDate: '',
        maxDate: '',
        jobId: '',
        jobTimer: '',
        loader: false,
        report: [],
        total_count: 0,
        showReport: false,
        downloadUrl: ''
    }),
    created() {
        this.maxDate = moment(new Date()).format('YYYY-MM-DD')
    },
    mounted() {
        this.getEnv()
    },
    methods: {
        reportChange() {
            if(this.selectedReportType != 'tbe') {
                this.report = []    
                this.showReport = false
            }
        },
        downloadReport(){
            window.open(this.downloadUrl, '_blank')
            this.resetInput()
        },
        resetInput() {
            this.selectedEnv = ''
            this.selectedTenet = ''
            this.startDate = ''
            this.endDate = ''
            this.selectedReportType = ''
            this.downloadUrl = ''
            this.startdateMenu = false
            this.enddateMenu = false
            this.loader = false
            this.$refs.startmenu.save(this.startDate)
            this.$refs.endmenu.save(this.endDate)
            this.showReport = false
            clearInterval(this.jobTimer)
                this.jobTimer = ''
        },
        getEnv() {
            axios({
                url: process.env.VUE_APP_API + '/env/info?info_type=env',
                method: 'get'
            }).then((res) => {
                console.log(res);
                this.envList = res.data.data
                this.envList = this.envList.filter(item => !(item == 'Admin'))
                this.reportList = Object.entries(res.data.usage_report_types).map((key) => {
                    return {name: key[1], id: key[0]}
                })
            }).catch((err) => {
                this.errorAlert = true
                this.errorMessage = err.response.data.message
                setTimeout(() => {
                    this.errorAlert = false
                }, 3000)
            })
        },
        getTenet(val) {
            axios({
                url: process.env.VUE_APP_API + '/env/tenants?target_env=' + val,
                method: 'get'
            }).then((res) => {
                console.log(res);
                this.tenetList = res.data.companies
            }).catch((err) => {
                this.errorAlert = true
                this.errorMessage = err.response.data.message
                setTimeout(() => {
                    this.errorAlert = false
                }, 3000)
            })
        },
        getRepost() {
            let payload = {
                from_date_range: this.startDate,
                to_date_range: this.endDate,
                task_type: 'view',
                target_env: this.selectedEnv,
                target_company_id: this.selectedTenet,
                report_type: this.selectedReportType
            }
            console.log(payload);
            this.loader = true
            axios({
                url: process.env.VUE_APP_API + '/consumptionreport',
                method: 'post',
                data: payload
            }).then((res) => {
                console.log('repo id => ', res);
                if(!res.data.success) {
                    this.loader = false
                    this.showReport = false
                    this.errorAlert = true
                    this.errorMessage = res.data.message
                    setTimeout(() => {
                        this.errorAlert = false
                    }, 3000)
                }
                if (this.selectedReportType == 'tbe' && res.data.success) {
                    this.showReport = true
                }
                if (res.data.job_id && res.data.success) {
                    this.jobId = res.data.job_id
                    this.jobTimer = setInterval(this.pollJobView, 1000);   
                } else {
                    this.report = []
                    this.total_count = 0
                    this.loader = false
                }
            }).catch((err) => {
                 this.loader = false
                this.errorAlert = true
                this.errorMessage = err.response.data.message
                setTimeout(() => {
                    this.errorAlert = false
                }, 3000)
                clearInterval(this.jobTimer)
                this.jobTimer = ''
                this.showReport = false
            })
        },
        exportRepost() {
            let payload = {
                from_date_range: this.startDate,
                to_date_range: this.endDate,
                task_type: 'export',
                target_env: this.selectedEnv,
                target_company_id: this.selectedTenet,
                report_type: this.selectedReportType
            }
            console.log(payload);
            this.loader = true
            axios({
                url: process.env.VUE_APP_API + '/consumptionreport',
                method: 'post',
                data: payload
            }).then((res) => {
                console.log(res);
                if(!res.data.success) {
                    this.loader = false
                    this.errorAlert = true
                    this.errorMessage = res.data.message
                    setTimeout(() => {
                        this.errorAlert = false
                    }, 3000)
                }
                if (res.data.job_id && res.data.success) {
                    this.jobId = res.data.job_id
                    this.jobTimer = setInterval(this.pollJobEport, 1000);   
                }
            }).catch((err) => {
                clearInterval(this.jobTimer)
                this.jobTimer = ''
                this.errorAlert = true
                this.errorMessage = err.response.data.message
                setTimeout(() => {
                    this.errorAlert = false
                }, 3000)
            })
        },
        pollJobEport() {
            axios({
                url: process.env.VUE_APP_API + '/consumptionreport/job?job_id=' + this.jobId + '&job_type=export',
                method: 'get'
            }).then((res) => {
                console.log('export => ',res.data);
                if (res.data.progress == 100 && this.selectedReportType == 'tbe') {
                    this.loader = false
                    window.open(res.data.report_s3_file_url, '_blank')  
                    clearInterval(this.jobTimer)
                    this.jobTimer = '' 
                } else if(res.data.progress == 100 && this.selectedReportType != 'tbe') {
                    this.downloadUrl = res.data.report_s3_file_url
                    console.log('downloadUrl => ', this.downloadUrl);                    
                    clearInterval(this.jobTimer)
                    this.jobTimer = ''  
                    this.loader = false
                    this.snackbar = true
                    setTimeout(() => {
                        this.snackbar = false
                    }, 3000)
                }
            }).catch((err) => {
                 this.errorAlert = true
                this.errorMessage = err.response.data.message
                setTimeout(() => {
                    this.errorAlert = false
                }, 3000)
                clearInterval(this.jobTimer)
                this.jobTimer = ''
            })
        },
        pollJobView() {
            axios({
                url: process.env.VUE_APP_API + '/consumptionreport/job?job_id=' + this.jobId + '&job_type=view',
                method: 'get'
            }).then((res) => {
                if (res.data.status == 'success') {
                    clearInterval(this.jobTimer)
                    this.showReport = true
                    this.loader = false
                    this.jobTimer = ''
                    this.report = res.data.data[2].report
                    this.total_count = res.data.data[1].total_mr_count
                    res.data.data[2].report.forEach((itm, i) => {
                        let key1 = Object.keys(itm.items)
                        let item1 = []
                        let item2 = []
                        let item3 = []
                        key1.forEach((ky) => {
                            item1.push({name: ky})
                            item2.push({val: itm.items[ky]})
                            item3.push({name: ky, type: ''})
                        })
                        let key2 = Object.keys(itm.item_categories)
                        // console.log('item => ', item1);
                        key2.forEach((ky) => {
                            item3.forEach((km) => {
                                if (ky == km.name) {
                                    km.type = itm.item_categories[ky]   
                                }
                            })
                        })
                        this.report[i].item_type = item1
                        this.report[i].item_cat = item2
                        this.report[i].item_cnt = item3
                    })
                    console.log('report => ', this.report);
                }
            }).catch((err) => {
                 this.errorAlert = true
                this.errorMessage = err.response.data.message
                setTimeout(() => {
                    this.errorAlert = false
                }, 3000)
                this.loader = false
                clearInterval(this.jobTimer)
                this.jobTimer = ''
                this.showReport = false
            })
        }
    }
}
</script>
<style lang="scss">
.report-drop {
    .v-text-field__details {
        display: none !important;
    }
}
</style>
<style lang="scss" scoped>
    .usage-reports {
        text-align: left;
        
    }
    .loader {
        position: fixed;
        bottom: 24px;
        right: 24px;
        background-color: #fff;
        z-index: 10;
        box-shadow: 5px 3px 30px 6px #ddd;
        padding: 24px;
        border-radius: 16px;
    }
    .report-table {
        width: 100%;
    }
    .item-row:not(:last-child) {
        border-bottom: 1px solid #ddd;

    }
</style>